import { TabsList, TabsTrigger } from "@capacit-com/lara-law-shared-ui";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@capacit-com/lara-law-shared-ui";
import { cn } from "@/lib/utils";
import {
  History,
  BookOpen,
  Link2,
  FileQuestion,
  type LucideIcon,
} from "lucide-react";
import { FC } from "react";

// eslint-disable-next-line react-refresh/only-export-components
export enum DocumentTab {
  CHAT_REFERENCES = "chatReferences",
  VERSION_HISTORY = "history",
  DOCUMENT_REFERENCES = "documentReferences",
  DOCUMENT_METADATA = "documentMetadata",
  TABLE_OF_CONTENTS = "tableOfContents",
}

type TabConfig = {
  icon: LucideIcon;
  tooltip: string;
};

const tabConfigs: Record<DocumentTab, TabConfig> = {
  [DocumentTab.CHAT_REFERENCES]: {
    icon: BookOpen,
    tooltip: "Chathenvisninger",
  },
  [DocumentTab.VERSION_HISTORY]: {
    icon: History,
    tooltip: "Versionshistorik",
  },
  [DocumentTab.DOCUMENT_REFERENCES]: {
    icon: Link2,
    tooltip: "Dokumentreferencer",
  },
  [DocumentTab.DOCUMENT_METADATA]: {
    icon: FileQuestion,
    tooltip: "Dokumentinformation",
  },
  [DocumentTab.TABLE_OF_CONTENTS]: {
    icon: BookOpen,
    tooltip: "Indholdsfortegnelse",
  },
};

type DocumentTabTriggersProps = {
  activeTab: DocumentTab;
  availableTabs: DocumentTab[];
};
const DocumentTabTriggers: FC<DocumentTabTriggersProps> = ({
  activeTab,
  availableTabs,
}) => {
  return (
    <TabsList className="bg-transparent h-full w-full flex justify-between">
      <TooltipProvider delayDuration={300}>
        {availableTabs.map((tab) => {
          const config = tabConfigs[tab];
          const Icon = config.icon;
          const isActive = activeTab === tab;

          return (
            <Tooltip key={tab}>
              <TooltipTrigger asChild>
                <TabsTrigger value={tab} className="px-3 cursor-pointer">
                  <Icon
                    className={cn("size-4", {
                      "text-primary": isActive,
                      "text-muted-foreground": !isActive,
                    })}
                  />
                </TabsTrigger>
              </TooltipTrigger>
              <TooltipContent side="bottom">
                <p>{config.tooltip}</p>
              </TooltipContent>
            </Tooltip>
          );
        })}
      </TooltipProvider>
    </TabsList>
  );
};

export default DocumentTabTriggers;
